/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
import React from 'react'
import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined'
import StoreOutlinedIcon from '@material-ui/icons/StoreOutlined'
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline'
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined'
import InboxOutlinedIcon from '@material-ui/icons/InboxOutlined'
import TrendingUpOutlinedIcon from '@material-ui/icons/TrendingUpOutlined'
import CallToActionOutlinedIcon from '@material-ui/icons/CallToActionOutlined'
import AccountBalanceOutlinedIcon from '@material-ui/icons/AccountBalanceOutlined'
import LocalShippingOutlinedIcon from '@material-ui/icons/LocalShippingOutlined'
import GroupAddIcon from '@material-ui/icons/GroupAdd'
import { ReactComponent as BarcodeIcon } from '@assets/icons/bar-code.svg'
import Cookies from 'js-cookie'
import MoneyIcon from '@material-ui/icons/Money'
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet'
import LoyaltyIcon from '@material-ui/icons/Loyalty'
import StarBorderOutlinedIcon from '@material-ui/icons/StarBorderOutlined'
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined'
import AddShoppingCartOutlinedIcon from '@material-ui/icons/AddShoppingCartOutlined'
import DeviceHubIcon from '@material-ui/icons/DeviceHub'

const breadcrumb = {
  '/account': 'Akun Saya',
  '/change-password': 'Ubah kata sandi',
  '/customers/details': 'Detail Customer',
  '/product-management/details': 'Detail Produk dan Stok',
  '/product-information/details': 'Detail Produk',
  '/purchase-order-items/details': 'Detail Pembelian Barang',
  '/sales-order-items/details': 'Detail Pesanan Reseller',
  '/order-management/details': 'Detail Penjualan',
  '/affiliates-withdraw-request/details': 'Detail Permintaan Withdraw',
  '/notifications': 'Notifikasi',
  '/pre-order/details': 'Detail Pembelian Pre Order',
}

export const menu = {
  reseller: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      link: '/dashboard',
      icon: <TrendingUpOutlinedIcon />,
      breadcrumb: {
        '/dashboard': 'Dashboard',
      },
    },
    {
      id: 'customers',
      title: 'Manajemen Customer',
      link: '/customers',
      icon: <PeopleOutlineIcon />,
      breadcrumb: {
        '/customers': 'Manajemen Customer',
      },
    },
    {
      id: 'product-management',
      title: 'Daftar Produk dan Stok',
      link: '/product-management',
      icon: <InboxOutlinedIcon />,
      breadcrumb: {
        '/product-management': 'Daftar Produk dan Stok',
      },
    },
    {
      id: 'purchase-order-items',
      title: 'Pembelian Barang',
      link: '/purchase-order-items',
      icon: <ShoppingCartOutlinedIcon />,
      breadcrumb: {
        '/purchase-order-items': 'Pembelian Barang',
      },
      has_notif: true,
      notif_id: 'purchase_order',
    },
    {
      id: 'sales-order-items',
      title: 'Pesanan Reseller',
      link: '/sales-order-items',
      icon: <ShoppingCartOutlinedIcon />,
      breadcrumb: {
        '/sales-order-items': 'Pesanan Reseller',
      },
      hide_child: true,
      has_notif: true,
      notif_id: 'sales_order',
    },
    {
      id: 'order-management',
      title: 'Penjualan',
      link: '/order-management',
      icon: <StoreOutlinedIcon />,
      breadcrumb: {
        '/order-management': 'Penjualan',
      },
      has_notif: true,
      notif_id: 'order_management',
    },
    {
      id: 'pre-order',
      title: 'Pre Order',
      link: '/pre-order',
      icon: <AddShoppingCartOutlinedIcon />,
      breadcrumb: {
        '/pre-order': 'Pre Order',
      },
      has_notif: true,
      notif_id: 'pre_order',
    },
    {
      id: 'order-channel',
      title: 'Channel Penjualan',
      link: '/order-channel',
      icon: <DeviceHubIcon />,
      breadcrumb: {
        '/order-channel': 'Channel Penjualan',
      },
    },
    {
      id: 'product-information',
      title: 'Marketing Kit',
      link: '/product-information',
      icon: <CallToActionOutlinedIcon />,
      breadcrumb: {
        '/product-information': 'Marketing Kit',
      },
    },
    {
      id: 'bank-accounts',
      title: 'Pengaturan Akun Bank',
      link: '/bank-accounts',
      icon: <AccountBalanceOutlinedIcon />,
      breadcrumb: {
        '/bank-accounts': 'Pengaturan Akun Bank',
      },
    },
    {
      id: 'courier-setup',
      title: 'Pengaturan Kurir',
      link: '/setup-courier',
      icon: <LocalShippingOutlinedIcon />,
      breadcrumb: {
        '/setup-courier': 'Pengaturan Kurir',
      },
      hide_dropship: true,
    },
    {
      id: 'members',
      title: 'Member',
      link: '/members',
      icon: <GroupAddIcon />,
      breadcrumb: {
        '/members': 'Member',
      },
      hide_child: true,
    },
    {
      id: 'member-purchase-reports',
      title: 'Laporan Pembelian Member',
      link: '/member-purchase-reports',
      icon: <AssessmentOutlinedIcon />,
      breadcrumb: {
        '/member-purchase-reports': 'Laporan Pembelian Member',
      },
      hide_commision: true,
      hide_child: true,
    },
    {
      id: 'member-sales-reports',
      title: 'Laporan Penjualan Member',
      link: '/member-sales-reports',
      icon: <AssessmentOutlinedIcon />,
      breadcrumb: {
        '/member-sales-reports': 'Laporan Penjualan Member',
      },
      hide_commision: true,
      hide_child: true,
    },
    {
      id: 'top-up',
      title: 'Top Up',
      link: '/top-up',
      icon: <MoneyIcon />,
      breadcrumb: {
        '/top-up': 'Top Up',
      },
      hide_commision: true,
    },
    {
      id: 'balance-log',
      title: 'Riwayat Saldo',
      link: '/balance-log',
      icon: <AccountBalanceWalletIcon />,
      breadcrumb: {
        '/balance-log': 'Riwayat Saldo',
      },
    },
    {
      id: 'commission-report',
      title: 'Laporan Komisi',
      link: '/commission-report',
      icon: <DescriptionOutlinedIcon />,
      breadcrumb: {
        '/commission-report': 'Laporan Komisi',
      },
      hide_discount: true,
    },
    {
      id: 'point-reward',
      title: 'Poin & Reward',
      link: '/point-reward',
      icon: <StarBorderOutlinedIcon />,
      breadcrumb: {
        '/point-reward': 'Poin & Reward',
      },
    },
    {
      id: 'my-reward',
      title: 'Reward Saya',
      link: '/my-reward',
      icon: <LoyaltyIcon />,
      breadcrumb: {
        '/my-reward': 'Reward Saya',
      },
      has_notif: true,
      notif_id: 'customer_reward',
    },
  ],
  affiliate: [
    {
      id: 'affiliates-list-product',
      title: 'Daftar Produk',
      link: '/affiliates-list-product',
      icon: <InboxOutlinedIcon />,
      breadcrumb: {
        '/affiliates-list-product': 'Daftar Produk',
      },
    },
    {
      id: 'affiliates-list-order',
      title: 'Penjualan',
      link: '/affiliates-list-order',
      icon: <ShoppingCartOutlinedIcon />,
      breadcrumb: {
        '/affiliates-list-order': 'Penjualan',
      },
    },
    {
      id: 'affiliates-withdraw-request',
      title: 'Permintaan Withdraw',
      link: '/affiliates-withdraw-request',
      icon: <BarcodeIcon />,
      breadcrumb: {
        '/affiliates-withdraw-request': 'Permintaan Withdraw',
      },
    },
    {
      id: 'transaction',
      title: 'Transaksi',
      link: '/transaction',
      icon: <BarcodeIcon />,
      breadcrumb: {
        '/transaction': 'Transaksi',
      },
    },
  ],
}

export const breadcrumbs = () => {
  const newBreadcrumb = breadcrumb
  const scope = Cookies.get('scope')

  // eslint-disable-next-line array-callback-return
  menu[scope].map((item) => {
    if (item.breadcrumb) {
      Object.assign(newBreadcrumb, item.breadcrumb)
    } else if (item.child) {
      item.child.map((item2) => Object.assign(newBreadcrumb, item2.breadcrumb))
    }
  })

  return breadcrumb
}
